import gql from 'graphql-tag';

export const CreateParticipantNote = gql`
  mutation CreateParticipantNote($organizationId: ID!, $request: CreateParticipantNoteRequest!) {
    createParticipantNote(organizationId: $organizationId, request: $request) {
      id
    }
  }
`;
